export default __webpack_public_path__ + "static/media/ic-previous-test.21fad7b7.svg";